export { default } from './ImageViewerHero';
